<template>
  <div class="all">
    <div class="fullScreen" style="pointer-events: auto;">
      <div v-watermark="watermarkConfig" style="width:100%;height:100%;z-index:999;position:absolute;pointer-events: none;"></div>
      <div class="hover_top_nav">
        <div>
          <div class="top_all">
            <FSvg title="全屏" IconSize="25" color="#fff" @click.native="handleFullscreen" v-if="!fullScreen"></FSvg>
            <FSvg title="退出全屏" IconSize="25" color="#fff" @click.native="handleFullscreen" v-else></FSvg>
          </div>
        </div>
      </div>
      <el-scrollbar ref="scrollbar" class="canvasScrollbar" :native="false" v-if="adapt">
        <div :style="{height:pageSize.height + 'px',width:pageSize.width + 'px'}" class="screen_page_chart" v-if="show">
          <backChart :back="allData.back"></backChart>
          <VueDragResize v-for="(item,index) in vuex.chartList" class="FCharsDrog" :key="index" :preventActiveBehavior="true" :w="parseFloat(item.trans.width)" :h="parseFloat(item.trans.height)" :x="parseFloat(item.trans.x)" :y="parseFloat(item.trans.y)" :parentLimitation="true">
            <charts :option="item" :index="index"></charts>
          </VueDragResize>
        </div>
      </el-scrollbar>
      <div :style="{height:pageSize.height + 'px',width:pageSize.width + 'px'}" class="screen_page_chart" v-if="show&&!adapt">
        <backChart :back="allData.back"></backChart>
        <VueDragResize v-for="(item,index) in vuex.chartList" class="FCharsDrog" :key="index" :preventActiveBehavior="true" :w="parseFloat(item.trans.width)" :h="parseFloat(item.trans.height)" :x="parseFloat(item.trans.x)" :y="parseFloat(item.trans.y)" :parentLimitation="true">
          <charts :option="item" :index="index"></charts>
        </VueDragResize>
      </div>
    </div>
    <!-- <div class="password" v-if="password==false">
      <div class="Verification">
        <div class="code">请输入分享码</div>
        <div class="el-input">
          <input type="text" maxlength="4" class="codeInput" v-model="code" onkeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" autocomplete="off" placeholder="分享码（注意区分大小写）" @keyup="code=check(code)">
        </div>
        <div class="ok" @click="enter1()">确定</div>
      </div>
    </div> -->
  </div>
</template>

<script>
/**
 @author xiaoye
 @date 2020/7/8 12:54 下午
 */
import router from '@/router'
import backChart from '../../charts/backChart'
import VueDragResize from 'vue-drag-resize';
import charts from '../../charts/charts'
import {
  GetScreenPageIndexByID,
  GetScreenByGroupID,
  GetScreenLinkSharing
} from '@/assets/axios/createScreen/configScreen'
import modules from '../../../charts/script/modules'

export default {
  name: 'fullScreen',
  components: {
    VueDragResize,
    charts,
    backChart,
  },
  props: {
    name: {
      type: String,
      default: ''
    },
  },
  watch: {},
  data() {
    return {
      watermarkConfig: {//水印
        text: '智步云上',
        font: '20px 微软雅黑',
        textColor: '#bcbcbc',
        width: 540, //水印文字的水平间距
        height: 220,  //水印文字的高度间距（低于文字高度会被替代）
        extRotate: -30 //-90到0， 负数值，不包含-90
      },
      captchaID: "",
      code: "",
      password: false,
      rotationTime: "",//秒数
      nextScreen: true,//下一张大屏id
      show: false,
      //id
      viewScree: {
        //模版id
        modeId: '',
        //大屏id
        viewDPId: ''
      },
      chartList: [],
      pageSize: {
        width: 0,
        height: 0
      },
      //自适应宽高
      adapt: false,
      //全屏
      fullScreen: false,
    }
  },
  methods: {
    async init() {
      let viewDPId = this.$route.params.id;
      let viewDPType = this.$route.params.type;
      if (viewDPId) {
        this.viewScree.viewDPId = viewDPId;
      } else {
        this.getMsg('请求失败 请重新尝试');
      }
      $('#ff_body').css({ 'min-width': 'auto' });
      if (viewDPType === '1') {
        this.adapt = true;
      }
      this.enter1()
    },
    check(str) {
      var temp = "";
      for (var i = 0; i < str.length; i++)
        if (str.charCodeAt(i) > 0 && str.charCodeAt(i) < 255)
          temp += str.charAt(i)
      return temp
    },
    async enter1() {
      this.show = false;
      this.captchaID = window.location.href.slice(-72, -36)
      var screenID = window.location.hash.slice(-36)
      await GetScreenLinkSharing({
        screenID: screenID,// 大屏ID
        captchaID: this.captchaID
      }).then(async res => {
        if (res.code === 200) {
          // this.getMsg('分享码正确', 'success');
          this.password = true;
          let node = res.data;
          document.getElementsByTagName('title')[0].innerHTML = node.screenPageName || '大屏预览页面';
          this.pageSize.width = node.sizeX || 0;
          this.pageSize.height = node.sizeY || 0;
          this.show = true;
          try {
            this.$nextTick(async () => {
              this.show = true;
              let pageParam = JSON.parse(node.screenJson);
              if (!pageParam.back.checkedVal1) {
                this.nextScreen = false;
              }
              this.nextScreen = pageParam.back.rotationID
              this.rotationTime = pageParam.back.rotationTime * 1000;
              let defaultVal = this.$store.state.designer.defaultVal;
              this.allData = JSON.parse(JSON.stringify(await this.getDGCopy(defaultVal.pageParam, pageParam)));
              let modu = modules;
              await this.$store.dispatch('screenAllRender', { modu, node });
              if (this.adapt) {
                await this.getInnerHeight('.screen_page_chart');
              }
            })
          } catch (e) {
            this.show = false;
          }
        }
      })
      if (this.nextScreen) {
        setTimeout(() => {
          this.enter2()
        }, this.rotationTime);
      }
    },
    async enter2() {
      this.show = false;
      var hash = window.location.href
      await GetScreenLinkSharing({
        screenID: this.nextScreen,// 大屏ID
        captchaID: this.captchaID
      }).then(async res => {
        if (res.code === 200) {
          this.password = true;
          let node = res.data;
          document.getElementsByTagName('title')[0].innerHTML = node.screenPageName || '大屏预览页面';
          this.pageSize.width = node.sizeX || 0;
          this.pageSize.height = node.sizeY || 0;
          this.show = true;
          try {
            this.$nextTick(async () => {
              this.show = true;
              let pageParam = JSON.parse(node.screenJson);
              if (!pageParam.back.checkedVal1) {
                this.nextScreen = false;
              }
              this.nextScreen = pageParam.back.rotationID
              this.rotationTime = pageParam.back.rotationTime * 1000;
              let defaultVal = this.$store.state.designer.defaultVal;
              this.allData = JSON.parse(JSON.stringify(await this.getDGCopy(defaultVal.pageParam, pageParam)));
              let modu = modules;
              await this.$store.dispatch('screenAllRender', { modu, node });
              if (this.adapt) {
                await this.getInnerHeight('.screen_page_chart');
              }
            })
          } catch (e) {
            this.show = false;
          }
        }
      })
      if (this.nextScreen) {
        setTimeout(() => {
          this.enter2()
        }, this.rotationTime);
      }
    },

    //查询当前页面的子图表
    async getChart() {
      this.show = false;
      await GetScreenPageIndexByID({
        screenID: this.viewScree.viewDPId
      }).then(async res => {
        if (res.code === 200) {
          let node = res.data;
          document.getElementsByTagName('title')[0].innerHTML = node.screenPageName || '大屏预览页面';
          this.pageSize.width = node.sizeX || 0;
          this.pageSize.height = node.sizeY || 0;
          this.show = true;
          try {
            this.$nextTick(async () => {
              this.show = true;
              let pageParam = JSON.parse(node.screenJson);
              if (!pageParam.back.checkedVal1) {
                this.nextScreen = false;
              }
              this.nextScreen = pageParam.back.rotationID
              this.rotationTime = pageParam.back.rotationTime * 1000;
              this.viewScree.viewDPId = pageParam.back.rotationID;
              let defaultVal = this.$store.state.designer.defaultVal;
              this.allData = JSON.parse(JSON.stringify(await this.getDGCopy(defaultVal.pageParam, pageParam)));
              let modu = modules;
              await this.$store.dispatch('screenAllRender', { modu, node });
              if (this.adapt) {
                await this.getInnerHeight('.screen_page_chart');
              }
            })
          } catch (e) {
            this.show = false;
          }
        }
      });
      if (this.viewScree.viewDPId) {
        setTimeout(() => {
          this.getChart()
        }, this.rotationTime);
      }
    },
    getInnerHeight(body) {
      let width = window.innerWidth;
      if (width <= this.pageSize.width) {
        let trIn = width / this.pageSize.width;
        let id = $(body);
        id.css({ 'zoom': trIn });
      }
    },
    //全屏
    handleFullscreen() {
      let main = document.body
      if (this.fullScreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        }
        this.fullScreen = false;
      } else {
        if (main.requestFullscreen) {
          main.requestFullscreen()
        } else if (main.mozRequestFullScreen) {
          main.mozRequestFullScreen()
        } else if (main.webkitRequestFullScreen) {
          main.webkitRequestFullScreen()
        } else if (main.msRequestFullscreen) {
          main.msRequestFullscreen()
        }
        this.fullScreen = true;
      }
    },
  },
  computed: {
    //公共的参数
    nowChart() {
      return this.$store.state.designer.nowChart;
    },
    vuex() {
      return this.$store.state.designer;
    },
    allData: {
      get() {
        return JSON.parse(JSON.stringify(this.vuex.defaultVal.pageParam));
      },
      set(data) {
        return data
      }
    },
    config() {
      return this.option.setting.params;
    },
  },
  created() {
  },
  mounted() {
    this.init();
    $(window).off('resize');
    $(window).on('resize', () => {
      if (this.adapt) {
        this.getInnerHeight('.screen_page_chart');
      }
    });
  },
  async beforeDestroy() {
    $('#ff_body').css({ 'min-width': '1000px' });
    await this.$store.dispatch('clearDesigner');
  }
}
</script>

<style lang="less">
.all {
}
.password {
  width: 100%;
  height: 100%;
  background: url("../../../../../../public/image/login_bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  position: absolute;
  top: 0;
  left: 0;
  .Verification {
    width: 500px;
    height: 300px;
    padding: 30px;
    background: url("../../../../../../public/image/register_bg.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-250px) translateY(-150px);
    .code {
      margin: 0 auto;
      text-align: left;
      font-size: 22px;
      color: #00fefe;
    }
    .el-input {
      width: 100%;
      position: relative;
      font-size: 14px;
      display: inline-block;
      margin: 60px 0;
      .codeInput {
        width: 100%;
        height: 40px;
        line-height: 40px;
        padding: 0 15px;
        font-size: 14px;
        border-radius: 2px;
        border: solid 1px #00fdfe;
        background: rgba(0, 253, 254, 0.2);
        color: #fff;
        outline: none;
      }
    }
    .ok {
      background: #00fdfe;
      border-radius: 2px;
      font-size: 16px;
      color: #000;
      letter-spacing: 2px;
      font-weight: 500;
      width: 100px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      float: right;
      cursor: pointer;
    }
    .ok:hover {
      opacity: 0.9;
    }
  }
}

.fullScreen {
  width: 100%;
  height: 100%;

  .hover_top_nav {
    position: absolute;
    top: 0;
    right: 20px;
    height: 40px;
    z-index: 9999;
    width: 400px;

    > div {
      display: inline-block;
      width: 100%;
      height: 100%;
      background: transparent;
      text-align: right;
      padding: 0 20px;
      line-height: 40px;

      .top_all {
        display: inline-block;
      }
    }
  }

  .hover_top_nav:hover {
    > div {
      display: inline-block;
      height: 100%;
      width: 100%;
      background: transparent;
      text-align: right;
      padding: 0 20px;
      line-height: 40px;
      .top_all {
        display: inline-block;
      }
    }
  }

  .el-scrollbar {
    width: 100%;
    height: 100%;
  }

  .el-scrollbar__wrap {
    overflow-x: hidden;
  }
  .canvasScrollbar {
    overflow: hidden;
  }

  .screen_page_chart {
    overflow: hidden;
    position: relative;
    // animation: scrollOne 3s 1;
    // animation-fill-mode: forwards;
    // animation-delay: 2s; //延迟时间(默认值为0)
  }
  // @keyframes scrollOne {
  //   0% {
  //     opacity: 1;
  //   }
  //   100% {
  //     opacity: 0;
  //   }
  // }
}
// .red {
//   background: skyblue;
//   position: absolute;
//   overflow: hidden;
//   top: 0;
//   left: 0;
//   opacity: 0;
//   animation: scroll 3s 1;
//   animation-fill-mode: forwards;
//   animation-delay: 2s; //延迟时间(默认值为0)
// }
// @keyframes scroll {
//   0% {
//     opacity: 0;
//   }
//   100% {
//     opacity: 1;
//   }
// }
</style>
